import Loading from './src/main'

export default Loading
